// extracted by mini-css-extract-plugin
export default {"optionWrapper":"styles_optionWrapper__7feSb","iconWrapper":"styles_iconWrapper__a-RKR"};